import ledgerApi from "@/api/ledger";

const getDefaultState = () => ({
  onReadyAccounts: [],
  onReadyAccountsLoading: false,
  onReadyAccountsError: false,
  onReadyAccountsErrorResponse: null,
});

const state = getDefaultState();

const mutations = {
  FETCH_ON_READY_ACCOUNTS_BEGIN(state) {
    state.onReadyAccountsLoading = true;
    state.onReadyAccountsError = false;
    state.onReadyAccountsErrorResponse = null;
  },
  FETCH_ON_READY_ACCOUNTS_SUCCESS(state, payload) {
    state.onReadyAccounts = [...payload.data];
    state.onReadyAccountsLoading = false;
  },
  FETCH_ON_READY_ACCOUNTS_FAILED(state, error) {
    state.onReadyAccountsLoading = false;
    state.onReadyAccountsError = true;
    state.onReadyAccountsErrorResponse = error;
  },

  UPDATE_ON_READY_ACCOUNTS_LOCAL(state, payload) {
    const account = state.onReadyAccounts.find(e => e.dd_reference === payload.dd_reference);
    account.ready = !payload.ready;
  },

  RESET_ON_READY_STORE(state) {
    Object.assign(state, getDefaultState());
  },
};

const actions = {
  async fetchOnReadyAccounts({ dispatch, commit }) {
    commit('FETCH_ON_READY_ACCOUNTS_BEGIN');
    try{
      const response = await ledgerApi.fetchOnReadyAccounts();
      commit('FETCH_ON_READY_ACCOUNTS_SUCCESS', { ...response.headers, data: response.data });
    } catch(error) {
      commit('FETCH_ON_READY_ACCOUNTS_FAILED', error);
      dispatch("alerts/setAlert", { type: "error", message: error.response.data.message }, { root: true });
    }
  },
};

const getters = {
  getOnReadyAccounts: state => state.onReadyAccounts,
  getOnReadyAccountInReady: state => state.onReadyAccounts.filter(e => e.ready).map(e => e.dd_reference),
  getOnReadyAccountsLoading: state => state.onReadyAccountsLoading,
  getOnReadyAccountsError: state => state.onReadyAccountsError,
  getOnReadyAccountsErrorResponse: state => state.onReadyAccountsErrorResponse,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
  